import { useTranslation } from "react-i18next";
import { EmptyState } from "shared/components";
import { GridItem } from "styled-system/jsx";

type OperatorDoorstopEmptyCardProps = {
  numOfOperators: number;
  onAddListingClick: () => void;
};

export const OperatorDoorstopEmptyCard = ({
  numOfOperators,
  onAddListingClick,
}: OperatorDoorstopEmptyCardProps) => {
  const { t } = useTranslation("core", { keyPrefix: "DOORSTOP" });
  return (
    <GridItem
      minW={"200px"}
      minH={"140px"}
      w={"full"}
      colSpan={numOfOperators % 2 ? 1 : 2}
      display={{
        base: numOfOperators < 1 ? "inherit" : "none",
        md: "inherit",
      }}
    >
      <EmptyState
        text={numOfOperators < 1 ? t("OPERATORS.EMPTY") : undefined}
        ctaButtonProps={{
          children: t("OPERATORS.ADD_A_LISTING"),
          size: "md",
          onClick: onAddListingClick,
        }}
        minH={"140px"}
        width={"full"}
      />
    </GridItem>
  );
};
